import React from 'react';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

export const TaskListPage: React.FC = () => {
  return (
    <div style={{ padding: 20, maxWidth: 900, margin: '0 auto' }}>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 12,
          marginBottom: 16,
        }}
      >
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(255, 184, 0, 0.12)',
            color: '#d97706',
          }}
        >
          <Inventory2OutlinedIcon fontSize="small" />
        </div>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: 'var(--text-primary)' }}>
            Task Roadmap Archived
          </h2>
          <p style={{ margin: '4px 0 0', color: 'var(--text-secondary)', fontSize: 13 }}>
            The old Forge planning board was removed because it described a variant architecture and
            workflow that no longer match the live system.
          </p>
        </div>
      </div>

      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--border)',
          borderRadius: 8,
          padding: 16,
          color: 'var(--text-secondary)',
          lineHeight: 1.6,
          fontSize: 14,
        }}
      >
        Use the Database page and the current backend/frontend code as the source of truth for:
        Mongo collections, Master Label behavior, and Forge variant lifecycle.
      </div>
    </div>
  );
};
